import React, { Fragment } from 'react';

import DayTrailDesktop from './DayTrailDesktop';
import DayTrailMobile from './DayTrailMobile';
import { DesktopScreen, MobileScreen } from '../../../components/ResponsiveScreens';

export default function DayTrail(props) {
  return (
    <Fragment>
      <DesktopScreen>
        <DayTrailDesktop {...props} />
      </DesktopScreen>
      <MobileScreen>
        <DayTrailMobile {...props} />
      </MobileScreen>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Trek/DayTrail/DayTrail.js